import { render, staticRenderFns } from "./SimpleAns.vue?vue&type=template&id=526bbaba"
import script from "./SimpleAns.vue?vue&type=script&lang=js"
export * from "./SimpleAns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports